import React, { useEffect, useState } from "react";
import { message, Select, Alert } from "antd";
import DashboardLayout from "../layout";
import Header from "../header/Header";
import CustomButton from "../shared/common/customButton";
import CountrySelectInput from "../shared/countrySelectInput";
import ServiceTempIOR from "./servicesTemp/tempIOR";
import { api, API_BASE_URL } from "../../config/api";
import { toast } from "react-toastify";
import { FaArrowLeft } from "react-icons/fa6";
import { Navigate, useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import axios from "axios";
import MultiCountrySelectInput from "../shared/countrySelectInput/MultiCountrySelectInput";
import TestPopup from './TestPopup';

const { Option } = Select;

const UpdateIORFormAdmin = () => {
  const initialFormData = {
    loadCountry: [],
    unloadCountry: "",
    airfreightCurrency: "USD",
    afcWeightUnit: "kg",
    selectedTemplate: {
      name: "",
      services: []
    },
  };

  const [values, setValues] = useState(initialFormData);
  const [validationErrors, setValidationErrors] = useState({});
  const [templateSelected, setTemplateSelected] = useState(false);
  const [isFormTouched, setIsFormTouched] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);
  const [savedServices, setSavedServices] = useState([]);
  const [isTestPopupVisible, setIsTestPopupVisible] = useState(false);


  const navigate = useNavigate();



  const [estimationExists, setEstimationExists] = useState(false);
  const [matchingCountries, setMatchingCountries] = useState([]);



  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    setIsFormTouched(true);

    // Reset estimation exists when form changes
    setEstimationExists(false);
    setMatchingCountries([]);
  };

  const handleSelectChange = (name, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));

    setIsFormTouched(true);

    // Reset estimation exists when form changes
    setEstimationExists(false);
    setMatchingCountries([]);
  };

  const checkEstimationExists = async () => {
    if (
      values.loadCountry.length > 0 &&
      values.unloadCountry &&
      values.airfreightCurrency &&
      values.afcWeightUnit &&
      values.selectedTemplate.name
    ) {
      try {
        const response = await api.post(`${API_BASE_URL}/estimates/check-exists`, {
          loadCountry: values.loadCountry,
          unloadCountry: values.unloadCountry,
          airfreightCurrency: values.airfreightCurrency,
          afcWeightUnit: values.afcWeightUnit,
          templateName: values.selectedTemplate.name
        });
        setEstimationExists(response.data.exists);
        setMatchingCountries(response.data.matchingCountries || []);
      } catch (error) {
        console.error("Error checking estimation existence:", error);
      }
    } else {
      // Reset estimation exists if form is incomplete
      setEstimationExists(false);
      setMatchingCountries([]);
    }
  };

  const validateForm = () => {
    if (!isFormTouched) return true;

    let formErrors = {};
    let isValid = true;

    if (!values.afcWeightUnit) {
      formErrors.afcWeightUnit = "Weight Unit is required";
      isValid = false;
    }

    if (!values.airfreightCurrency) {
      formErrors.airfreightCurrency = "Airfreight Currency is required";
      isValid = false;
    }

    if (!values.loadCountry || values.loadCountry.length === 0) {
      formErrors.loadCountry = "Load Country is required";
      isValid = false;
    }

    if (!values.unloadCountry) {
      formErrors.unloadCountry = "Unload Country is required";
      isValid = false;
    }

    if (!values.selectedTemplate || !values.selectedTemplate.name) {
      formErrors.selectedTemplate = "A template must be selected";
      isValid = false;
    }

    if (!values.selectedTemplate.services || values.selectedTemplate.services.length === 0) {
      formErrors.services = "At least one service is required";
      isValid = false;
    } else {
      const invalidServices = values.selectedTemplate.services.filter(
        service => !service.description || service.values.length === 0
      );
      if (invalidServices.length > 0) {
        formErrors.services = "All services must have a description and at least one value";
        isValid = false;
      }
    }

    setValidationErrors(formErrors);
    setIsFormValid(isValid && !estimationExists);
    return isValid;
  };

  useEffect(() => {
    if (isFormTouched) {
      validateForm();
    }
    // Add a small delay to avoid rapid API calls
    const timeoutId = setTimeout(() => {
      checkEstimationExists();
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [values, savedServices, isFormTouched]);


  const validateServices = (services) => {
    let isValid = true;
    let errorMessage = "";

    services.forEach((service, index) => {
      if (!service.description || service.description.trim() === '') {
        isValid = false;
        errorMessage = `Service ${index + 1}: Description is required`;
        return;
      }
      if (service.values.length === 0) {
        isValid = false;
        errorMessage = `Service ${index + 1}: At least one value is required`;
        return;
      }
      service.values.forEach((value, valueIndex) => {
        if (value === '') {
          isValid = false;
          errorMessage = `Service ${index + 1}: Value at position ${valueIndex + 1} cannot be empty`;
          return;
        }
      });
    });

    return { isValid, errorMessage };
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsFormTouched(true);

    if (!validateForm() || estimationExists) {
      toast.error(estimationExists ? "Estimation already exists for the selected criteria" : "Please fill all mandatory fields and ensure all services are properly filled");
      return;
    }

    const { isValid, errorMessage } = validateServices(savedServices);
    if (!isValid) {
      toast.error(errorMessage);

      return;
    }

    const formattedData = {
      ...values,
      selectedTemplate: {
        name: values.selectedTemplate.name,
        services: savedServices
      },
    };

    try {
      const response = await api.post(`${API_BASE_URL}/estimates/estimates`, formattedData);

      if (response.status === 201) {
        toast.success("Form saved successfully");
        navigate("/settings");
      } else {
        toast.error("Error saving form");
      }
    } catch (error) {
      console.error("Unexpected error", error);
      if (error.response && error.response.data && error.response.data.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("An unexpected error occurred");
      }
    }
  };
  const selectStyle = `
      w-full  text-sm  outline-none
      focus:border-blue-500
    `;

  const onBack = () => {
    navigate("/settings");
  };

  const handleTestClick = (e) => {
    e.preventDefault(); // Prevent form submission
    e.stopPropagation(); // Stop event propagation
    setIsTestPopupVisible(true);
  };

  const handleTestPopupClose = () => {
    setIsTestPopupVisible(false);
  };

  return (
    <DashboardLayout>
      <div className="w-full">
        <Header title="Add New IOR" />
        <div className="p-4 bg-cus-gray">
          <div className="mb-3">
            <button
              type="button"
              onClick={onBack}
              className="flex rounded-[5px] items-center space-x-4 py-2 px-4 text-white btnBg"
            >
              <FaArrowLeft className="mr-2" /> Back
            </button>
          </div>
          <form
            onSubmit={handleSubmit}
            className="p-4 mx-auto bg-white border rounded-md"
          >
            {estimationExists && (
              <Alert
                message="Estimation already exists"
                description={`Estimations already exist for the following load countries: ${matchingCountries.join(", ")}`}
                type="warning"
                showIcon
                className="mb-4"
              />
            )}
            <div className="mx-[30px] flex flex-wrap md:flex-nowrap gap-3 mt-4">
              <div className="w-full md:w-1/3">
                <label
                  className="w-full text-sm font-normal"
                  htmlFor="loadCountry"
                >
                  Load Country <span className="text-red-500">*</span>
                </label>
                <MultiCountrySelectInput
                  name="loadCountry"
                  id="loadCountry"
                  placeholder="Select Countries"
                  value={values.loadCountry}
                  onChange={handleChange}

                />
                {isFormTouched && validationErrors.loadCountry && (
                  <p className="text-red-500 text-sm mt-1">{validationErrors.loadCountry}</p>
                )}
              </div>
              <div className="w-full md:w-1/3">
                <label
                  className="w-full text-sm font-normal"
                  htmlFor="unloadCountry"
                >
                  Unload Country <span className="text-red-500">*</span>
                </label>
                <CountrySelectInput
                  name="unloadCountry"
                  id="unloadCountry"
                  placeholder="Select Countries"
                  value={values.unloadCountry}
                  onChange={handleChange}
                />
                {isFormTouched && validationErrors.unloadCountry && (
                  <p className="text-red-500 text-sm mt-1">{validationErrors.unloadCountry}</p>
                )}
              </div>

              <div className="flex w-full md:w-1/3 gap-3">
                <div className="w-full md:w-1/2">
                  <label
                    htmlFor="airfreightCurrency"
                    className="block mb-1 text-sm font-medium text-gray-700"
                  >
                    Currency <span className="text-red-500">*</span>
                  </label>
                  <Select
                    id="airfreightCurrency"
                    className={selectStyle}
                    value={values.airfreightCurrency}
                    onChange={(value) =>
                      handleSelectChange("airfreightCurrency", value)
                    }
                  >
                    <Option value="USD">USD</Option>
                    <Option value="EUR">EUR</Option>
                    <Option value="GBP">GBP</Option>
                  </Select>
                </div>

                <div className="w-full md:w-1/2">
                  <label
                    htmlFor="afcWeightUnit"
                    className="block mb-1 text-sm font-medium text-gray-700"
                  >
                    Weight Unit <span className="text-red-500">*</span>
                  </label>
                  <Select
                    id="afcWeightUnit"
                    className={selectStyle}
                    value={values.afcWeightUnit}
                    onChange={(value) =>
                      handleSelectChange("afcWeightUnit", value)
                    }
                  >
                    <Option value="kg">kg</Option>
                    <Option value="lbs">lbs</Option>
                  </Select>
                </div>
              </div>
            </div>

            <div>

              <ServiceTempIOR
                formData={values}
                setFormData={setValues}
                validationErrors={isFormTouched ? validationErrors : {}}
                setValidationErrors={setValidationErrors}
                templateSelected={templateSelected}
                setTemplateSelected={setTemplateSelected}
                savedServices={savedServices}
                setSavedServices={setSavedServices}
              />

            </div>

            <div className="mx-[30px] flex flex-col gap-3 sm:flex-row justify-between mt-4">
              <div className="flex gap-2 items-center">
                <CustomButton
                  label="Save"
                  onClick={handleSubmit}
                  disabled={!isFormValid || estimationExists}
                  className={(!isFormValid || estimationExists) ? 'opacity-50 cursor-not-allowed' : ''}
                />
                <CustomButton
                  label="Test"
                  onClick={handleTestClick}
                  className="bg-green-500 text-white"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <TestPopup
        isVisible={isTestPopupVisible}
        onClose={handleTestPopupClose}
        formData={values}
        key={isTestPopupVisible ? 'open' : 'closed'} // Force re-render on open/close
      />
    </DashboardLayout>
  );
};

export default UpdateIORFormAdmin;